/**
 * Kayan slogan/etiket şeridi — sürekli hareket eden marquee ribbon.
 * Ambalajın alt kısımlarındaki "Vegan · Glutensiz · Organik" gibi
 * etiketleri hatırlatan bir efekt.
 */
export default function Marquee({
  items = [
    'Amasra · Karadeniz',
    'Sertifikalı Organik',
    'Katkısız · Doğal',
    'Private Label',
    'Türkiye Geneli Teslimat',
    'Toptan Fiyat',
    'Vegan · Glutensiz',
    'Kavanozdan Sofraya',
  ],
  dark = false,
  speed = 40,
}) {
  const bg = dark ? 'bg-[#1F1F1F] text-[#FBF7EE]' : 'bg-[#B03A2E] text-[#FBF7EE]';
  const dotColor = dark ? 'bg-[#B08834]' : 'bg-[#FBF7EE]/60';

  return (
    <div
      className={`${bg} overflow-hidden py-5 md:py-6 border-y border-current/10 relative`}
      aria-hidden
    >
      <div
        className="flex whitespace-nowrap"
        style={{
          animation: `marquee ${speed}s linear infinite`,
        }}
      >
        {[...items, ...items, ...items].map((item, i) => (
          <span key={i} className="flex items-center gap-8 pr-8">
            <span className="font-display italic text-xl md:text-3xl lg:text-4xl font-light">
              {item}
            </span>
            <span className={`w-2 h-2 rounded-full ${dotColor}`} />
          </span>
        ))}
      </div>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-33.3333%); }
        }
      `}</style>
    </div>
  );
}
